module.exports = __webpack_public_path__ + "assets/img/bp_d_i_6.982066f3.jpg";